import { Directive, inject, input, OnInit } from '@angular/core';
import { MatSelect } from '@angular/material/select';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'mat-select[customSelectOverlayClass]',
  standalone: true
})
export class CustomSelectOverlayDirective implements OnInit {
  customSelectOverlayClass = input<string>('');

  private readonly matSelect = inject(MatSelect);

  ngOnInit(): void {
    const overlayClass = this.customSelectOverlayClass();
    if (overlayClass && this.matSelect) {
      // Direct assignment bypassing the rigid public API limitation
      // eslint-disable-next-line @typescript-eslint/no-explicit-any,no-underscore-dangle
      (this.matSelect as any)._overlayPanelClass = overlayClass;
    }
  }
}
